__webpack_require__.p = "https://cdn.dgtalguide.com/web/bundles/8c03eba/";